import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/components/ArchitectureCanvasScreen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/AppLayout.tsx");
